

const PAGE_SIZE = 20;

class Service {

    constructor(name) {
        this.table = new window.BaaS.TableObject(name);
    }

    $find(query, options) {
        let q = this.table;
        if(query){
            q = q.setQuery(query);
        }
        if ('select' in options) {
            q = q.select(options['select']);
        }
        if ('orderBy' in options) {
            q = q.orderBy(options['orderBy']);
        }
        if ('pageSize' in options) {
            q.limit(options['pageSize']);
        }
        if('expand' in options){
            q.expand(options['expand']);
        }
        if ('page' in options) {
            let page = options['page'] || 1;
            let pageSize = options['pageSize'] || PAGE_SIZE;
            q.offset((page - 1) * pageSize);
        }
        return q;
    }

    find(query, options = {}) {
        return new Promise((resolve, reject) => {
            this.$find(query, options).find({
                withCount: !!options['withCount']
            }).then(res => {
                resolve(res.data);
            }, err => {
                reject(err);
            });
        });
    }

    count(query, options = {}) {
        return this.$find(query, options).count();
    }

    get(id) {
        return new Promise((resolve, reject) => {
            return this.table.get(id).then(res => {
                resolve(res.data);
            }, err => {
                reject(err);
            });
        });
    }

    delete(idOrQuery, options) {
        return this.table.delete(idOrQuery, options);
    }

    create(data) {
        let record = this.table.create();
        return record.set(data).save();
    }

    update(id, data, options) {
        let record = this.table.getWithoutData(id);
        return record.set(data).update(options);
    }

    save(data, options){
        if('id' in data){
            let {id, ...rest} = data;
            if(id){
                return this.update(id, rest, options);
            }
            return this.create(rest);
        }
        return this.create(data);
    }
}

export default function service(name) {
    return new Service(name);
}